import { urlCategoryList, urlProductList } from '@/urls';
import { Outlet } from 'react-router';
import { route as productListRoute } from './product-list';
import { route as categoryListRoute } from './category-list';
import { Tabs } from '@repo/ui/components/tabs';
import { useCurrentClub } from '@/hooks/use-current-club';

function ProductLayout() {
  const club = useCurrentClub();
  return (
    <div className="flex flex-col gap-4 h-full">
      <Tabs
        tabs={[
          { label: 'Productos', link: urlProductList(club.id) },
          { label: 'Categorías', link: urlCategoryList(club.id) },
        ]}
      />
      <Outlet />
    </div>
  );
}

export const route = {
  path: urlProductList(':id'),
  element: <ProductLayout />,
  children: [productListRoute, categoryListRoute],
};
